import {useMutation} from 'react-query';
import {request} from '../utils/axios-utils';

const deleteUser = (id)=>{
    return request({url:`/user/${id}`, method:'DELETE'})
}


export const useDeleteUser = (onSuccess, onError) => {
    return useMutation((id)=>deleteUser(id),{
        onSuccess: onSuccess?onSuccess:null,
        onError: onError?onError:null,
    });
}